import { SelfDescribingJson } from '@snowplow/tracker-core';

import { SwitchContext } from '../contexts/SwitchContext';

export const mapSwitchContext = (
  switchContext: SwitchContext,
): SelfDescribingJson<Record<string, unknown>> => {
  const { value } = switchContext;

  return {
    schema: 'iglu:com.genially/switch/jsonschema/1-0-0',
    data: {
      value,
    },
  };
};
